import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import { DMM_API_HOST, DMM_API_KEY } from '../../../_Components/Common/common'
import {
  InputGroup,
  FormControl,
  Button,
  Dropdown,
  DropdownButton,
} from 'react-bootstrap'

const Filter = props => {
  const [cFilter, setCFilter] = useState([])
  const [iFilter, setIFilter] = useState([])
  const [cText, setCText] = useState([])
  const [iText, setIText] = useState([])

  useEffect(() => {
    getFilter()
  }, [])

  const getFilter = async () => {
    await axios
      .get(`${DMM_API_HOST}/v4.0.1/assistant/filter`, {
        headers: {
          apikey: DMM_API_KEY,
        },
      })
      .then(({ data }) => {
        console.log(data)
        setCFilter(data.body.character)
        setIFilter(data.body.image)
      })
  }

  const insertFilter = async (type, text) => {
    await axios
      .post(
        `${DMM_API_HOST}/v4.0.1/assistant/filter`,
        { type, filter: text },
        {
          headers: {
            apikey: DMM_API_KEY,
          },
        }
      )
      .then(() => {
        if (type === 'character') setCText('')
        if (type === 'image') setIText('')
        alert('success')
        getFilter()
      })
  }

  const deleteFilter = async seq => {
    await axios
      .delete(`${DMM_API_HOST}/v4.0.1/assistant/filter/${seq}`, {
        headers: {
          apikey: DMM_API_KEY,
        },
      })
      .then(() => {
        alert('deleted')
        getFilter()
      })
  }

  const handleSubmit = async (e, type) => {
    e.preventDefault()
    await insertFilter(type, type === 'character' ? cText : iText)
  }

  const keyEvent = async (e, type) => {
    if (e.key === 'Enter') {
      handleSubmit(e, type)
    }
  }

  return (
    <div
      className="content-wrapper"
      style={{ minHeight: '100%', marginLeft: '0' }}
    >
      <section className="content-header">
        <h1>DMM Assistant Filter</h1>
        <ol className="breadcrumb">
          <li>
            <i className="fa fa-dashboard"></i>DMM
          </li>
          <li className="active">Filter</li>
        </ol>
      </section>
      <section className="content">
        <div className="row">
          {/* <!-- Left col --> */}
          <section className="col-lg-12 connectedSortable">
            {/* <!-- Custom tabs (Charts with tabs)--> */}
            <div className="box box-info" style={{ padding: '0 10px' }}>
              {/* <!-- /.box-header --> */}
              <b>Character Prompt Filter</b>
              <div className="box-body">
                <InputGroup onSubmit={e => handleSubmit(e, 'character')}>
                  <FormControl
                    type="text"
                    value={cText}
                    placeholder="Filter"
                    onChange={e => setCText(e.target.value)}
                    onKeyPress={e => keyEvent(e, 'character')}
                  />
                  <Button
                    variant="primary"
                    onClick={e => handleSubmit(e, 'character')}
                    style={{ height: '38px' }}
                  >
                    <i className="fa fa-plus" />
                  </Button>
                </InputGroup>
                <div style={{ marginTop: 20 }}>
                  <FilterWrapper>
                    {cFilter.length > 0 &&
                      cFilter.map((f, i) => (
                        <FilterItem key={i} onClick={() => deleteFilter(f.seq)}>
                          {f.filter}
                        </FilterItem>
                      ))}
                  </FilterWrapper>
                </div>
              </div>
            </div>
          </section>
          <section className="col-lg-12 connectedSortable">
            {/* <!-- Custom tabs (Charts with tabs)--> */}
            <div className="box box-info" style={{ padding: '0 10px' }}>
              {/* <!-- /.box-header --> */}
              <b>Image Prompt Filter</b>
              <div className="box-body">
                <InputGroup onSubmit={e => handleSubmit(e, 'image')}>
                  <FormControl
                    type="text"
                    value={iText}
                    placeholder="Filter"
                    onChange={e => setIText(e.target.value)}
                    onKeyPress={e => keyEvent(e, 'image')}
                  />
                  <Button
                    variant="primary"
                    onClick={e => handleSubmit(e, 'image')}
                    style={{ height: '38px' }}
                  >
                    <i className="fa fa-plus" />
                  </Button>
                </InputGroup>
                <div style={{ marginTop: 20 }}>
                  <FilterWrapper>
                    {iFilter.length > 0 &&
                      iFilter.map((f, i) => (
                        <FilterItem key={i}>{f.filter}</FilterItem>
                      ))}
                  </FilterWrapper>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </div>
  )
}

export default Filter

const FilterWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px 8px;
`

const FilterItem = styled.div`
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #dc143c;
    color: #fff;
  }
`
